import React from 'react'
import Sheet from '@amzn/meridian/sheet'
import Row from '@amzn/meridian/row'
import Button from '@amzn/meridian/button'
import Icon from '@amzn/meridian/icon'
import closeMediumTokens from '@amzn/meridian-tokens/base/icon/close-medium'
import { useBundle } from '@amzn/react-arb-tools'
import { useFeatureFlag } from '@services/featureFlags'
import NotificationsPage from './index'
import ActionCenterPage from '@src/pages/ActionCenterPage'
import { t } from '@src/translationHelper'
import { BUNDLE_NAME } from '@src/constants'
import './NotificationsSheet.scss'

interface INotificationsSheetProps {
    open: boolean
    onClose: () => void
}

/**
 * Bottom sheet behind the bell icon. Renders the Gateway-fed Action Center when the
 * `golden_gate_in_app_notification_page_v2` flag is on, otherwise the legacy Virgo-fed notification center.
 */
export const NotificationsSheet: React.FC<INotificationsSheetProps> = ({ open, onClose }) => {
    const { enabled: actionCenterEnabled } = useFeatureFlag('golden_gate_in_app_notification_page_v2')
    const { enabled: closeButtonEnabled } = useFeatureFlag('notification_drawer_close_button_v1')
    const [bundle] = useBundle(BUNDLE_NAME)
    return (
        <Sheet
            type="overlay"
            side="bottom"
            open={open}
            onClose={onClose}
            spacingInset="none"
            data-atb-id="notifications-sheet"
            // See ProfileSettingsSheet: `className` lands on the positioned outer container.
            className="notifications-sheet"
            motionDuration={0}
        >
            <div className="notifications-sheet-content">
                {/* Close affordance matching the Profile & Settings sheet (ProfileSettingsPage
                    renderBackButton). The drawer previously had no dismiss control, so the only
                    way out was the bottom nav / profile icon, which navigate away. Gated behind
                    notification_drawer_close_button_v1 for staged rollout. P525189101. */}
                {closeButtonEnabled && (
                    <Row alignmentVertical="center" alignmentHorizontal="right" spacingInset="300 none">
                        <Button type="icon" onClick={onClose} data-testid="notifications-close-button">
                            <Icon tokens={closeMediumTokens}>
                                {t(bundle, 'jsma-web-common-close')}
                            </Icon>
                        </Button>
                    </Row>
                )}
                {actionCenterEnabled ? <ActionCenterPage /> : <NotificationsPage />}
            </div>
        </Sheet>
    )
}
